import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class AffiliateMarketingPlan extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            systemModules: []
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = this.httpPost("/api/v1/common/getsystemmodules", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.systemModules = data.records;
                }
            });

        var p2 = this.httpPost("api/v1/affiliatemarketingplan/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                }
                else {
                    this.showErorrMessage(data.message);
                }
            });

        Promise.all([p1, p2])
            .all(a => {
                this.setState({
                    loading: false
                });
            })
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/affiliatemarketingplan/save", {
            id: this.state.id,
            organizationId: this.state.data.global.company.id,
            targets: this.state.data.record.targets,
            title: this.state.data.record.title,
            isPublic: this.state.data.record.isPublic,
            isDefault: this.state.data.record.isDefault,
            description: this.state.data.record.description,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setPerson(e) {
        this.state.data.persons = e;
    }
    getBlankTarget() {
        return {
            id: this.uuidv4(),
            percent: 0,
            price: 0,
            saleCount: 0,
            type: 1,
            validOrderTypes: '',
            validSystemModules: '',
            renewPercent: 0,
            renewPrice: 0,
        }
    }
    addNewTarget() {
        this.state.data.record.targets.push(this.getBlankTarget());
        this.setState({ data: this.state.data });
    }
    removeTarget(id) {
        var temp = [];
        this.state.data.record.targets.forEach(t => {
            if (t.id !== id) temp.push(t);
        });

        this.state.data.record.targets = temp;
        this.setState({ data: this.state.data });
    }
    setTarget(id, f, e, e2 = null) {
        this.state.data.record.targets.forEach(t => {
            if (t.id === id) {
                if (f === 'validOrderTypes' || f === 'validSystemModules') {
                    if (f === 'validOrderTypes') {
                        t.validOrderTypes = t.validOrderTypes.replace('[' + e + ']', '');
                        if (e2 == true) t.validOrderTypes += '[' + e + ']';
                    }
                    if (f === 'validSystemModules') {
                        t.validSystemModules = t.validSystemModules.replace('[' + e + ']', '');
                        if (e2 == true) t.validSystemModules += '[' + e + ']';
                    }
                }
                else {
                    t[f] = parseInt(e);
                }
            }
        });

        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }} >
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات پلن" : "افزودن پلن جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxLength="100" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">توضیحات</label>
                                            <textarea defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} autocomplete="off" type="text" className="form-control input-sm"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <input defaultChecked={this.state.data.record.isDefault} onChange={e => this.state.data.record.isDefault = e.target.checked} type="checkbox" />
                                            پلن پیش فرض کاربران
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <input defaultChecked={this.state.data.record.isPublic} onChange={e => this.state.data.record.isPublic = e.target.checked} type="checkbox" />
                                            عمومی برای همه کاربران
                                        </div>
                                    </div>
                                </div>

                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">هدف گذاری سطوح تشویقی</h5>
                                        </div>
                                        {this.state.data.record.targets.map(target =>
                                            <div className="row g-4" key={target.id} style={{ "background-color": "#f4f4f4", "marginTop": "15px" }}>
                                                <div className="col-lg-2">
                                                    <div className="form-group">
                                                        <label className="form-label">عنوان</label>
                                                        <div className="form-control-wrap">
                                                            <select className="form-control" type="text" defaultValue={target.type} onChange={e => this.setTarget(target.id, 'type', parseInt(e.target.value))}>
                                                                <option value="1">مبلغ ثابت</option>
                                                                <option value="2">درصدی</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                {target.type === 1 && <div className="col-lg-2">
                                                    <div className="form-group">
                                                        <label className="form-label">مبلغ تمدید</label>
                                                        <div className="form-control-wrap">
                                                            <input className="form-control ltr" type="text" defaultValue={target.renewPrice} onChange={e => this.setTarget(target.id, 'renewPrice', e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>}
                                                {target.type === 2 && <div className="col-lg-2">
                                                    <div className="form-group">
                                                        <label className="form-label">درصد فروش</label>
                                                        <div className="form-control-wrap">
                                                            <input className="form-control ltr" type="text" defaultValue={target.percent} onChange={e => this.setTarget(target.id, 'percent', e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>}
                                                {target.type === 2 && <div className="col-lg-2">
                                                    <div className="form-group">
                                                        <label className="form-label">درصد تمدید</label>
                                                        <div className="form-control-wrap">
                                                            <input className="form-control ltr" type="text" defaultValue={target.renewPercent} onChange={e => this.setTarget(target.id, 'renewPercent', e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>}
                                                <div className="col-lg-2">
                                                    <div className="form-group">
                                                        <label className="form-label">حداقل تعداد فروش</label>
                                                        <div className="form-control-wrap">
                                                            <input className="form-control ltr" type="text" defaultValue={target.saleCount} onChange={e => this.setTarget(target.id, 'saleCount', e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <label className="form-label">فروش مجاز</label>
                                                        <div className="form-control-wrap">
                                                            <div className="ms-1" style={{ display: "inline-block" }}>
                                                                <input type="checkbox" defaultChecked={target.validOrderTypes.includes('[1]')} onChange={e => this.setTarget(target.id, 'validOrderTypes', '1', e.target.checked)} />
                                                                    خرید/تمدید ماژول
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                {target.validOrderTypes.includes('[1]') && <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <label className="form-label">ماژول های مجاز</label>
                                                        <div className="form-control-wrap">
                                                            {this.state.systemModules.map(module =>
                                                                <div className="ms-1" style={{ display: "inline-block" }}>
                                                                    <input type="checkbox" defaultChecked={target.validSystemModules.includes('[' + module.id + ']')} onChange={e => this.setTarget(target.id, 'validSystemModules', module.id, e.target.checked)} />
                                                                    {module.title}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>}                                             
                                                <div className="col-lg-1" style={{ "display": "flex", "align-items": "center" }}>
                                                    <div className="form-group">
                                                        <a className="btn btn-sm btn-danger" onClick={e => this.removeTarget(target.id)}>حذف</a>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="row g-4 mt-1">
                                            <div className="col-lg-12">
                                                <a className="btn btn-primary" onClick={e => this.addNewTarget()}>افزودن سطح جدید جدید</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}